import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import {
    trigger,
    transition,
    useAnimation,
    group
} from '@angular/animations';
import { fadeInDown, slideOutUp, fadeOut } from 'ng-animate';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('animation', [
            transition(':enter', useAnimation(fadeInDown, { params: { timing: 0.3 } })),
            transition(':leave', group([
                useAnimation(fadeOut, { params: { timing: 0.3 } }),
                useAnimation(slideOutUp, { params: { timing: 0.3 } }),
            ]))
        ]),
    ],
    standalone: false
})
export class AlertComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() level: 'success' | 'error' | 'warning' | 'info' = 'info';
    @Input() message: string;
    @Input() dismissDelay: number | undefined;

    @Output() dismissed = new EventEmitter<void>();
    @Output() fired = new EventEmitter();

    isOpen = false;
    dismissible = false;
    timeout: any;
    icons = {
        success: 'check-square',
        error: 'bomb',
        warning: 'exclamation-triangle',
        info: 'info-circle',
    };

    constructor(
        private cdRef: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.dismissible = this.dismissed.observed;
        if (this.dismissDelay) {
            this.timeout = setTimeout(() => {
                this.dismiss();
            }, this.dismissDelay);
        }

        setTimeout(() => {
            this.isOpen = true;
            this.cdRef.markForCheck();
        }, 300);
    }

    ngAfterViewInit(): void {
      this.fired.emit();
    }

    ngOnDestroy() {
        clearTimeout(this.timeout);
    }

    dismiss() {
        this.isOpen = false;
        this.cdRef.markForCheck();
    }

    onAnimationEvent() {
        if (!this.isOpen) {
            this.dismissed.emit();
        }
    }
}
